import {
  hasPermission,
  PermissionScope,
  type PermissionKeyEnum,
  type PermissionMap,
  type PermissionScopeEnum,
} from "@fitness-app/data-models";

export interface PermissionCheck {
  permission: PermissionKeyEnum;
  minimumScope?: PermissionScopeEnum;
}

export type PermissionRequirement =
  | PermissionCheck
  | { anyOf: readonly PermissionCheck[] }
  | { allOf: readonly PermissionCheck[] };

const matchesPermissionCheck = (permissions: PermissionMap, requirement: PermissionCheck): boolean =>
  hasPermission(permissions, requirement.permission, requirement.minimumScope ?? PermissionScope.ASSIGNED);

export const matchesPermissionRequirement = (
  permissions: PermissionMap,
  requirement: PermissionRequirement,
): boolean => {
  if ("anyOf" in requirement) {
    return requirement.anyOf.some((permissionCheck) => matchesPermissionCheck(permissions, permissionCheck));
  }

  if ("allOf" in requirement) {
    return (
      requirement.allOf.length > 0 &&
      requirement.allOf.every((permissionCheck) => matchesPermissionCheck(permissions, permissionCheck))
    );
  }

  return matchesPermissionCheck(permissions, requirement);
};
